/**
 * Hook: load risk controls for a risk (QMS Phase 2)
 */
import { useState, useEffect, useCallback } from 'react';
import { riskControlService } from '../services/riskControlService';

export function useRiskControls(riskId) {
  const [controls, setControls] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!riskId) {
      setControls([]);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const data = await riskControlService.getControlsByRiskId(riskId);
      setControls(data);
    } catch (err) {
      console.error('useRiskControls:', err);
      setError(err.message);
      setControls([]);
    } finally {
      setLoading(false);
    }
  }, [riskId]);

  useEffect(() => {
    load();
  }, [load]);

  return { controls, loading, error, refresh: load };
}
